export const LIVEKIT_CONFIG = {
  RETRY_COUNT_THRESHOLD: 3,
  RETRY_DELAY_MS: 3000,
};

export const LIVEKIT_TOPICS = {
  DHWANI_SESSION_END_EVENT: 'dhwani-session-end-event',
};

export const LIVEKIT_MESSAGE_TYPES = {
  SESSION_END: 'SESSION_END',
};

export const SCREEN_SHARE_CONFIG = (ScreenSharePresets, Track) => ({
  name: Track.Source.ScreenShare,
  dtx: true,
  red: true,
  forceStereo: false,
  simulcast: false,
  screenShareEncoding: ScreenSharePresets.h1080fps15.encoding,
  stopMicTrackOnMute: false,
  videoCodec: 'vp8',
  backupCodec: true,
  preConnectBuffer: false,
});

export const LIVEKIT_VIDEO_CONSTRAINTS = {
  width: 1280,
  height: 720,
  frameRate: 30,
};
export const GET_SESSION_RETRY_COUNT = 30;
